export interface IBlockedProductModel {
    products: string[];
}
